/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Row, Col } from 'react-bootstrap';

// import components below
import Layout from 'components/Layout';
import PageHeader from './components/PageHeader';
import SideBar from 'components/ACLComponents/SideBar';
import CredentialsManagementContainer from './components/CredentialsManagementContainer';

// main component
const CredentialsManagement = () => {
  return (
    <Layout pageTitle='Credentials Management'>
      <PageHeader />

      <Row className='mt-4'>
        <Col sm={9}>
          <CredentialsManagementContainer />
        </Col>
        <Col sm={3}>
          <SideBar />
        </Col>
      </Row>
    </Layout>
  );
};

export default CredentialsManagement;
